import { useState, useEffect } from "react"

const ProgressiveImage = ({
  lowResImage,
  highResImage,
  alt,
  className = "",
}) => {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    const img = new Image()
    img.src = highResImage
    img.onload = () => {
      setLoaded(true)
    }
  }, [highResImage])

  return (
    <img
      src={loaded ? highResImage : lowResImage}
      alt={alt}
      className={`rounded-2xl w-full ${className}`}
    />
  )
}

export default ProgressiveImage
